import script from "./Navi.vue?vue&type=script&setup=true&lang=js"
export * from "./Navi.vue?vue&type=script&setup=true&lang=js"

import "./Navi.vue?vue&type=style&index=0&id=4acac3dd&lang=css"

const __exports__ = script;

export default __exports__